import React from 'react';
import { Link } from 'react-router';
import { FileText } from 'lucide-react';
import { cn } from '@/lib/utils';
import { childReportHref } from '../automated/ChildAorReportSectionPanel';
import {
  useTaskReportLinks,
  type SectionTaskLinkWithReport,
} from './useSectionTaskLinks';

const reportHref = (link: SectionTaskLinkWithReport) =>
  link.sitrep_incident_id
    ? `/iap/${link.sitrep_incident_id}/reports?${new URLSearchParams({
        openReport: link.sitrep_id,
      }).toString()}`
    : childReportHref(link.sitrep_id, link.sitrep_aor_id);

type TaskReportLinksProps = {
  actionId: string | null | undefined;
  className?: string;
};

/**
 * Which report sections generated or pinned this task, with a link back to each
 * report.
 */
export default function TaskReportLinks({
  actionId,
  className,
}: TaskReportLinksProps) {
  const { data: links = [] } = useTaskReportLinks(actionId ? [actionId] : []);
  if (links.length === 0) return null;
  return (
    <ul
      className={cn(
        'tw:m-0 tw:list-none tw:space-y-1 tw:p-0 tw:text-sm',
        className
      )}
      data-testid="task-report-links"
    >
      {links.map((link) => (
        <li
          key={link.section_id}
          className="tw:flex tw:items-center tw:gap-1.5"
        >
          <FileText className="tw:size-4 tw:shrink-0 tw:text-muted-foreground" />
          <span>
            {link.source === 'generated'
              ? 'Generated from report'
              : 'Added to report'}{' '}
            <Link to={reportHref(link)} className="tw:underline">
              {link.sitrep_name || 'Untitled report'}
            </Link>
            {link.section_name ? ` (${link.section_name})` : null}
          </span>
        </li>
      ))}
    </ul>
  );
}
